import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/divisions', { params });
  },
  create(data) {
    return axios.post('/v1/divisions', data);
  },
  detail(id) {
    return axios.get(`/v1/divisions/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/divisions/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/divisions/${id}`);
  }
};
